import { render, staticRenderFns } from "./riskimppanel.vue?vue&type=template&id=353b7590&scoped=true"
import script from "./riskimppanel.vue?vue&type=script&lang=js"
export * from "./riskimppanel.vue?vue&type=script&lang=js"
import style0 from "./riskimppanel.vue?vue&type=style&index=0&id=353b7590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b7590",
  null
  
)

export default component.exports